import styled from 'styled-components'
import { Text } from 'common-components'
import { COLORS } from 'consts/colors'
import { customizeHorizontalScrollbarThumbMixin } from 'styles/mixins'

export const TagsContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  ${customizeHorizontalScrollbarThumbMixin()}
`

export const TagItem = styled(Text)`
  padding: 8px 12px;
  width: max-content;
  white-space: nowrap;
  border-radius: 6px;
  background-color: ${COLORS.primaryExtraLight};
`
